import { EXPENSE_POLICY_CONST } from '../actionConstants';
import {APPLICATION_CONSTANTS,PATHS} from '../../AppConstants';
import {getccbAxiosConfig} from '../../apisSetup/ccbConfig';
import {getCookie, saveServerLogs} from '../../UtilityComponents/Util';
import { formatEmployeesData, formatManagersData } from '../../expense/components/Policy/utils';
import {setApiSuccess} from './expenseActions';
import {unSavedStateStatus, setApiError, setApiLoading} from './expenseAdminActionDispatcher';
import {ADMIN_SCREEN_TYPES, defaultSuccessModalData, ADMIN_SCREENS} from '../../expense/pages/ExpenseAdmin/adminConfig';

const ccbAxiosApiCaller = getccbAxiosConfig(true, {
	[APPLICATION_CONSTANTS.DEVICE_TYPE_KEY] : APPLICATION_CONSTANTS.DEVICE_TYPE,
}, false);

const GENERIC_ERROR = 'We are facing some technical issue. Please try after sometime';

export const approvalInputs = ({ groupId, key, subKey, inputValue, isDefault, inputKey}) => ({
    type: EXPENSE_POLICY_CONST.APPROVAL_INPUTS,
    payload: {
        groupId,
        key,
        subKey,
        inputValue,
        isDefault,
        inputKey,
    }
});

export const getManagerList = (reqBody) => async dispatch => {
    try {
        const response = await ccbAxiosApiCaller.post(PATHS.EXPENSE_MANAGER, reqBody);
        const {data} = response || {};
        if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            const formattedData = formatManagersData(data.managerNotExistsCountList);
            dispatch({
                type: EXPENSE_POLICY_CONST.MANAGER_LIST,
                payload: formattedData
            })
        }
    } catch(err) {
        saveServerLogs(e.stack, 'error', PATHS.EXPENSE_MANAGER);
    }  
};

export const getEmployeeList = (searchString) => async (dispatch) => {
    try {
        const response = await ccbAxiosApiCaller.get(`${PATHS.EMPLOYEE_AUTOSUGGEST}/${searchString}`, {
            params: {
                viewManagerDetails: true,
                from: 0,
                pagesize: 20,
            }
        });
        const {data} = response || {};
        if (data && data.employees) {
            const formattedData = formatEmployeesData(data.employees);
            dispatch({
                type: EXPENSE_POLICY_CONST.EMPLOYEE_LIST,
                payload: formattedData
            })
        }
    } catch(err) {
        saveServerLogs(e.stack, 'error', PATHS.EMPLOYEE_AUTOSUGGEST);
    }
}

export const getPolicyGroups = (groupId) => async dispatch => {
    let errorObj = {screenType : ADMIN_SCREEN_TYPES.POLICY, errorMessage: ''}
    try{
        dispatch(apiLoader({tabLoader: true}))
        const response = await ccbAxiosApiCaller.get(PATHS.GET_POLICY_GROUPS);
        const responseData = response && response.data;
        if(responseData){
            errorObj['errorMessage'] = '';
			dispatch({
				type: EXPENSE_POLICY_CONST.POLICY_GROUPS,
				payload: {responseData, groupId}
			})
			return;
        }
        errorObj['errorMessage'] = responseData.message;
    }
    catch(e){
        errorObj['errorMessage'] = GENERIC_ERROR;
        saveServerLogs(e.stack, 'error', PATHS.GET_POLICY_GROUPS);
    }
    finally{
        errorObj && dispatch(setApiError(errorObj));
        dispatch(apiLoader({tabLoader: false}))
    }
}

export const getExpensePolicy = (selectedGroup, fetchDefaultPolicy = false) => async dispatch => {
    let errorObj = {screenType : ADMIN_SCREEN_TYPES.POLICY, errorMessage: ''}
    try{
        dispatch(apiLoader({policyLoader: true}))
        let url = `${PATHS.GET_POLICY}`;
        if(selectedGroup){
            url = `${url}?isDefaultGroup=${fetchDefaultPolicy}&groupIds=${selectedGroup}`    
        }
        else{
            url = `${url}?isDefaultGroup=${fetchDefaultPolicy}`;
        }       
        const response = await ccbAxiosApiCaller.get(url);
        const responseData = response && response.data;
		if(responseData){
            errorObj['errorMessage'] = '';
			dispatch({
				type: EXPENSE_POLICY_CONST.POLICY_DATA,
				payload: {responseData, selectedGroup, fetchDefaultPolicy}
			})
			return;
        }
        errorObj['errorMessage'] = responseData.message;
    }
    catch(e){
        errorObj['errorMessage'] = GENERIC_ERROR;
        saveServerLogs(e.stack, 'error', PATHS.GET_POLICY);
    }
    finally{
        errorObj && dispatch(setApiError(errorObj));
        dispatch(apiLoader({policyLoader: false}))
    }
}

export const updateDefaultSelectedGroup = (selectedGroupId,selectedGroupIndex) => async dispatch => {
    dispatch({
        type: EXPENSE_POLICY_CONST.UPDATE_DEFAULT_GROUP,
        payload: {selectedGroupId:selectedGroupId,selectedGroupIndex}
    });
}


export const updateGroupAndFetchPolicy = (selectedGroupId, policyData, selectedGroupIndex)  => async dispatch => {
    dispatch(updateDefaultSelectedGroup(selectedGroupId,selectedGroupIndex))
    if(!policyData[selectedGroupId]) {
        dispatch(getExpensePolicy(selectedGroupId))
    }
}

const apiLoader = (payload) => ({
   type: EXPENSE_POLICY_CONST.API_LOADING,
   payload: payload
})

export const saveExpensePolicy = (payload) => async dispatch => {
    let errorObj = {screenType : ADMIN_SCREEN_TYPES.POLICY, saveErrorMessage: ''}
    try{
        dispatch(setApiLoading({screenType : ADMIN_SCREEN_TYPES.POLICY, loader: true}));
        const response = await ccbAxiosApiCaller.post(PATHS.SAVE_POLICY, payload);
        const responseData = response && response.data;
        if(responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE){
            errorObj['saveErrorMessage'] = '';
            dispatch(unSavedStateStatus({screenType: ADMIN_SCREENS.POLICY_SCREEN, status: false}))
            dispatch(setApiSuccess({...defaultSuccessModalData}));
            return;
        }
        errorObj['saveErrorMessage'] = responseData.message;
    }
    catch(e){
        errorObj['saveErrorMessage'] = GENERIC_ERROR;
        saveServerLogs(e.stack, 'error', PATHS.SAVE_POLICY);
    }
    finally{
        dispatch(setApiError(errorObj));
        dispatch(setApiLoading({screenType : ADMIN_SCREEN_TYPES.POLICY, loader: false}));
    }
}

export const clearState = () => ({
    type: EXPENSE_POLICY_CONST.CLEAR_STATE
 })